// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-form-component-StatefulForm-module-errorBanner {
	background-color: var(--Red700);
	padding: 12px 24px;
	color: var(--PrimaryWhite);
}`, "",{"version":3,"sources":["webpack://./src/csi/middleware/form/component/StatefulForm.module.css"],"names":[],"mappings":"AAAA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,0BAA0B;AAC3B","sourcesContent":[".errorBanner {\n\tbackground-color: var(--Red700);\n\tpadding: 12px 24px;\n\tcolor: var(--PrimaryWhite);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorBanner": `csi-middleware-form-component-StatefulForm-module-errorBanner`
};
module.exports = ___CSS_LOADER_EXPORT___;
